// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"012cdbee","493":"6877458a","790":"011d857a","833":"2b7f9dc9"}[chunkId] + ".chunk.js";
};